import { useEffect, useState } from "react";

// What kind of screen the page is on, kept in step as it changes: wide
// enough for a split, or a touch screen with no pointer to hover (a tablet's
// or a phone's), where a key the person cannot type with a modifier, or a
// field too small to read without the page zooming, would be in the way.

/** Whether `query` matches now; `fallback` where there is no matchMedia (a test's jsdom). */
export function useMedia(query: string, fallback: boolean): boolean {
  const [on, setOn] = useState(() => (typeof window.matchMedia === "function" ? window.matchMedia(query).matches : fallback));
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const m = window.matchMedia(query);
    const change = () => setOn(m.matches);
    change();
    m.addEventListener("change", change);
    return () => m.removeEventListener("change", change);
  }, [query]);
  return on;
}

/** A screen with no pointer to hover: a tablet's or a phone's (RFC-043 "Web client", as 8f1811a's rows read it). */
export const NoHover = "(hover: none)";
